(() => {
  const toggleEl = document.querySelector('.js-toggle');
  const toggleImageEl = document.querySelector('.js-toggle-image');
  if (!toggleEl || !toggleImageEl) {
    return;
  }
  toggleEl.addEventListener('change', e => {
    const { checked } = e.target;
    if (checked) {
      toggleImageEl.classList.add('show');
    } else {
      toggleImageEl.classList.remove('show');
    }
  });
})();
